import { propStore } from '../util';

export default function toggleCallToActionButtonsToState(settings, disabled): void {
    const className = disabled ? settings.classNames.callToActionButton : settings.classNames.callToActionButtonDisabled;
    const buttons = Array.from(document.getElementsByClassName(className));

    buttons.forEach(button => {
        if (disabled) {
            button.className = settings.classNames.callToActionButtonDisabled;
            propStore.backup(button);
        }
        else {
            button.className = settings.classNames.callToActionButton;
            propStore.restore(button);
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/element-disabler/src/disablers/callToAction.ts